import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import IdentityDocumentModal from "./Modals/IdentityDocument";
import UpdateBVNModal from "./Modals/UpdateBvn";
import ProofOfResidenceModal from "./Modals/ProofOfResidence";
import {
  firebaseImageUpload,
  getIdentityDocumentTypes,
  getUploadedDocuments,
  identityDocumentUpload,
} from "./KycApis";
import UploadStatus from "./UploadStatus";

const KYC = () => {
  const user = useSelector((state) => state.user.user);
  const [getUpdatedBvn, setGetUpdateBvn] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [areFieldsSet, setAreFieldsSet] = useState(false);
  const [active, setIsActive] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [showProofOfResidenceModal, setShowProofOfResidenceModal] =
    useState(false);
  const [showBVNModal, setShowBVNModal] = useState(false);
  const [document, setDocument] = useState("");
  const [getDocumentsUploaded, setGetDocumentsUploaded] = useState([]);
  const [uploadStaus, setUploadStatus] = useState(false);
  const [documentType, setDocumentType] = useState([]);
  const [documentData, setDocumentData] = useState({
    documentURL: "",
    documentName: "",
    documentID: "",
    documentKey: "",
  });
  useEffect(() => {
    Object.values(documentData).includes("")
      ? setAreFieldsSet(false)
      : setAreFieldsSet(true);
  }, [documentData]);

  useEffect(() => {
    const { documentKey, ...others } = documentData;
    Object.values(others).includes("") ? setIsActive(false) : setIsActive(true);
  }, [documentData]);

  useEffect(() => {
    getIdentityDocumentTypes().then(({ status, data }) => {
      if (status === 200) {
        setDocumentType(data.documents);
      } 
    });
  }, []);

  useEffect(() => {
    setGetUpdateBvn(user.hasOwnProperty("bvn") ? user.bvn : "Not Available");
  }, [user]);

  useEffect(() => {
    getUploadedDocuments(user).then(({ status, data }) => {
      if (status === 200) {
        setGetDocumentsUploaded(data.documents);
        setUploadStatus(true);
      }
    });
  }, [user]);

  const updateBvn = (updatedBvn) => {
    setGetUpdateBvn(updatedBvn);
  };
  const resetDefault = () => {
    setDocumentData({
      documentURL: "",
      documentName: "",
      documentID: "",
      documentKey: "",
    });
    setIsProcessing(false);
    setShowModal(false);
    setShowProofOfResidenceModal(false);
  };
  const handleChange = (e) => {
    let index = e.nativeEvent.target.selectedIndex;
    let id = e.target.id;
    let documentName =
      id === "documentID"
        ? e.nativeEvent.target[index].text
        : documentData.documentName;
    setDocumentData({
      ...documentData,
      documentName,
      [id]: e.target.value,
    });
  };
  const handleDocumentChange = (e) => {
    setDocument(e.target.files[0]);
    setDocumentData({ ...documentData, documentURL: e.target.files[0].name });
  };

  const handleDocumentUpload = async (e) => {
    setIsProcessing(true);
    try {
      const url = await firebaseImageUpload(document);
      let randomKey = (Math.random() + 1).toString(36).substring(7);
      const document_id_check = Number(documentData.documentID);
      const payload = {
        document_url: url,
        document_name: documentData.documentName,
        document_id: Number(documentData.documentID),
        document_key:
          document_id_check === 32 ? randomKey : documentData.documentKey,
        user_id: user.id,
      };

      identityDocumentUpload(payload, resetDefault).then(({ status }) => {
        if (status === 200) {
          setUploadStatus(true);
          getUploadedDocuments(user).then(({ data }) => {
            setGetDocumentsUploaded(data.documents);
          });
          toast.success("Document Upload Successful");
          resetDefault();
        }
      });
    } catch (err) {
      toast.error(err);
      resetDefault();
    }
  };

  return (
    <>
      <div className="col-12 col-md-9 ">
        <div className="card card-bleed shadow-light-lg mb-6">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col">
                <h4 className="mb-0">Bank Verification Number</h4>
              </div>
              <div className="col-auto">
                <button
                  className="btn btn-xs btn-primary"
                  onClick={() => {
                    setShowBVNModal(!showBVNModal);
                  }}
                >
                  Update
                </button>
              </div>
            </div>
          </div>

          <div className="row align-items-center ms-7 ">
            <div className="col my-4">
              <p className="mb-0 text-primary">{getUpdatedBvn}</p>
            </div>
          </div>
        </div>

        {/* upload proof of residence document */}
        <div className="card card-bleed  shadow-light-lg mb-6">
          <div className="card-header">
            <div className="row align-items-center ">
              <div className="col-12 dropdown">
                <div
                  className="row  align-items-center  py-md-2 px-md-1 rounded"
                  id="dropdownUploadDocument"
                  data-bs-toggle="dropdown"
                >
                  <div className="col">
                    <h4 className="mb-0">Proof of Residence</h4>
                  </div>
                  <div className="col-auto">
                    <button
                      className="btn btn-xs btn-primary"
                      onClick={() => {
                        setShowProofOfResidenceModal(
                          !showProofOfResidenceModal
                        );
                      }}
                    >
                      Upload
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row align-items-center mx-4 ">
            {uploadStaus === true ? (
              getDocumentsUploaded.map((uploadedDocument) => (
                <div key={uploadedDocument.id}>
                  {uploadedDocument.description === "Address Document" && (
                    <>
                      <UploadStatus uploadedDocument={uploadedDocument} />
                    </>
                  )}
                </div>
              ))
            ) : (
              <div className="ms-7">not available</div>
            )}
          </div>
        </div>

        <div className="card card-bleed  shadow-light-lg mb-6">
          <div className="card-header">
            <div className="row align-items-center ">
              <div className="col-12 dropdown">
                <div
                  className="row  align-items-center  py-md-2 px-md-1 rounded"
                  id="dropdownUploadDocument"
                  data-bs-toggle="dropdown"
                >
                  <div className="col">
                    <h4 className="mb-0">Identity Document</h4>
                  </div>
                  <div className="col-auto">
                    <button
                      className="btn btn-xs btn-primary"
                      onClick={() => {
                        setShowModal(!showModal);
                      }}
                    >
                      Upload
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mx-4 px-0">
            {uploadStaus === true ? (
              getDocumentsUploaded.map((uploadedDocument) => (
                <div key={uploadedDocument.id}>
                  {uploadedDocument.description !== "Address Document" && (
                    <UploadStatus uploadedDocument={uploadedDocument} />
                  )}
                </div>
              ))
            ) : (
              <div className="ms-7">not available</div>
            )}
          </div>
        </div>
      </div>

      <IdentityDocumentModal
        showModal={showModal}
        setShowModal={setShowModal}
        handleDocumentUpload={handleDocumentUpload}
        handleDocumentChange={handleDocumentChange}
        handleChange={handleChange}
        documentType={documentType}
        areFieldsSet={areFieldsSet}
        isProcessing={isProcessing}
      />
      <ProofOfResidenceModal
        showProofOfResidenceModal={showProofOfResidenceModal}
        setShowProofOfResidenceModal={setShowProofOfResidenceModal}
        handleDocumentUpload={handleDocumentUpload}
        handleDocumentChange={handleDocumentChange}
        handleChange={handleChange}
        documentType={documentType}
        isProcessing={isProcessing}
        active={active}
      />
      <UpdateBVNModal
        showBVNModal={showBVNModal}
        setShowBVNModal={setShowBVNModal}
        updateBvn={updateBvn}
        user={user}
        isProcessing={isProcessing}
      />
    </>
  );
};

export default KYC;
